import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@portal-core/auth/services/api.service';
import { ProjectVariableSet } from '@portal-core/project-files/variables/models/project-variable-set.model';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariablesApiService {
  constructor(private http: HttpClient, private apiService: ApiService) { }

  @SharePendingRequest()
  getSystemVariableSets$(): Observable<ProjectVariableSet[]> {
    return this.http.get<ProjectVariableSet[]>(`${this.apiService.centralApiBaseUri}/api/projects/systemVariables`);
  }

  /**
   * Computes linked system variables on server side.
   * @param linkedSystemVariables Key - file path. Value - array of linked system variables (long variable name is used).
   * @returns Returns a dictionary with computed linked system variables. Key - file path. Value - its computed system variables: <name, value>.
   */
  @SharePendingRequest()
  computeLinkedSystemVariables$(linkedSystemVariables: Dictionary<string[]>, projectId: number, commitId: string): Observable<Dictionary<Dictionary<string>>> {
    return this.http.post<Dictionary<Dictionary<string>>>(`${this.apiService.centralApiBaseUri}/api/projects/${projectId}/computeLinkedSystemVariables?commitId=${encodeURIComponent(commitId)}`, linkedSystemVariables);
  }

}
